import { RatingCategory } from "@sona/shared-model-common";

export const ratingColors = {
    [RatingCategory.VERY_GOOD]: '#22c55e',
    [RatingCategory.GOOD]: '#22c55e',
    [RatingCategory.SATISFYING]: '#f59e0b',
    [RatingCategory.SUFFICIENT]: '#f59e0b',
    [RatingCategory.FAILED]: '#ef4444',
    [RatingCategory.COMPLETELY_FAILED]: '#ef4444'
};

export const ratingColorsDark = {
    [RatingCategory.VERY_GOOD]: '#15803d',
    [RatingCategory.GOOD]: '#15803d',
    [RatingCategory.SATISFYING]: '#b45309',
    [RatingCategory.SUFFICIENT]: '#b45309',
    [RatingCategory.FAILED]: '#b91c1c',
    [RatingCategory.COMPLETELY_FAILED]: '#b91c1c'
};
